import {useContext} from "react"
import {NavLink, useHistory} from "react-router-dom"
import {Menubar} from "primereact/menubar"
import {Button} from "primereact/button"
import {Badge} from "primereact/badge"
import confirmation from "../../function/confirmation"
import userContext from "../../context/userContext"
import notificationContext from "../../context/notificationContext"
import styles from "./styles.module.css"
import logo from "./logo.svg"
import logoText from "./logotext.svg"

export default function Navbar() {
  const history = useHistory()
  const handleNavigate = (e) => history.push(e.item.link)
  const user = useContext(userContext)
  const logoutConfirmation = (e) =>
    confirmation(e.currentTarget, "Opravdu odhlásit?", user.logout)

  const logout = (
    <Button onClick={logoutConfirmation} className={"p-button-sm lg:ml-3"}>
      Odhlásit ({user.user.name}, {user.user.operation.name})
    </Button>
  )

  const start = (
    <div className={"flex align-items-center mr-3"}>
      <img src={logoText} alt={"Logo"} width={125} className={"hidden lg:inline-block mr-2"}/>
      <img src={logo} alt={"Logo"} height={30} className={"lg:hidden mr-2"}/>
      <span className={styles.logoBold}>DORA</span>
      <span className={styles.logoThin}>MAINTENANCE</span>
    </div>
  )

  const end = (
    <div className={"flex align-items-center justify-content-between"}>
      <NavLink to={`/tasks?my_tasks=${user.user.uuid}`} title={"Moje úkoly"}
               className={`${styles.btnMyTasks} py-2 px-3`}>
        <i className={"fas fa-tasks fa-lg"}/>
      </NavLink>

      <notificationContext.Consumer>
        {({notifications, toggle}) => (
          <i className={"pi pi-bell py-2 px-3 p-overlay-badge text-xl cursor-pointer"}
             onClick={toggle} title={"Notifikace"}>
            {notifications.length > 0 && (
              <Badge value={`${notifications.length}`} severity={"danger"} className={styles.badge}/>
            )}
          </i>
        )}
      </notificationContext.Consumer>

      <span className={"hidden lg:block"}>
        {logout}
      </span>
    </div>
  )

  const items = [{
    label: "Domů",
    link: "/",
    command: handleNavigate,
  }, {
    label: "Úkoly",
    items: [{
      label: "Úkoly",
      link: "/tasks",
      command: handleNavigate,
    }, {
      label: "Stroje",
      link: "/tasks/machines",
      command: handleNavigate,
    },],
  }, {
    label: "Management",
    link: "/tasks/management",
    disabled: !user.hasPerm("ROLE_PERM_MANAGEMENT_READ"),
    command: handleNavigate,
  }, {
    label: "Sklad",
    link: "/warehouses",
    command: handleNavigate,
  }, {
    label: "Nastavení",
    disabled: !user.hasPerm("ROLE_PERM_ENUMS_WRITE"),
    items: [{
      label: "Stroje",
      link: "/enum/machines",
      command: handleNavigate,
    }, {
      label: "Typy strojů",
      link: "/enum/machine-types",
      command: handleNavigate,
    }, {
      label: "Pracovníci",
      link: "/enum/users",
      command: handleNavigate,
    }, {
      label: "Týmy",
      link: "/enum/teams",
      command: handleNavigate,
    }, {
      label: "Provozy",
      link: "/enum/operations",
      command: handleNavigate,
    }, {
      label: "Místa",
      link: "/enum/places",
      command: handleNavigate,
    }, {
      label: "Typy úkolů",
      link: "/enum/task-tags",
      command: handleNavigate,
    }, {
      label: "Sklad",
      items: [{
        label: "Seznam skladů",
        link: "/enum/warehouse/warehouses",
        command: handleNavigate,
      }, {
        label: "Dodavatelé",
        link: "/enum/warehouse/suppliers",
        command: handleNavigate,
      }, {
        label: "Kategorie",
        link: "/enum/warehouse/categories",
        command: handleNavigate,
      }, {
        label: "Umístění",
        link: "/enum/warehouse/positions",
        command: handleNavigate,
      }, {
        label: "Díly",
        link: "/enum/warehouse/parts",
        command: handleNavigate,
      },],
    },],
  }, {
    template: () => (
      <div className={"px-3 lg:hidden"}>{logout}</div>
    )
  },]

  return (
    <Menubar
      model={items}
      start={start}
      end={end}
      className={styles.navbar}
    />
  )
}
